import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerModel } from '@df/session/api/customer.model';

@Component({
    selector: 'newsletter-checkbox',
    templateUrl: './newsletter-checkbox.html'
})
export class NewsletterCheckboxComponent {
    private _model: boolean | undefined;

    @Input()
    get model(): boolean | undefined {
        return this._model;
    }
    set model(value: boolean | undefined) {
        if (this._model !== value) {
            this._model = value;
            this.modelChange.emit(value);
        }
    }

    @Output()
    modelChange = new EventEmitter<boolean>();

    constructor(readonly customerModel: CustomerModel) {}
}
